import { RenderSummaryCellProps } from 'react-data-grid'
import { GridColumn } from '../Grid'
import './Filter.scss'
import { useTranslation } from 'react-i18next'

interface FilterProps<T> {
  data: RenderSummaryCellProps<Record<string, string[] | undefined>, T>
  onChange: (key: string, value: string[] | undefined) => void
  onClick: (column: GridColumn<T>) => void
}
export function Filter<T>(props: FilterProps<T>) {
  const { t } = useTranslation()
  const column = props.data.column as unknown as GridColumn<T>
  const row = props.data.row
  let value = row[column.key]?.join(', ') ?? ''

  if (column.filterItems && row[column.key]) {
    value = row[column.key]!.map((val) => t(val.toUpperCase())).join(', ')
  }
  return column.filterBy ? (
    <div className="grid-filter">
      <input
        className={value ? 'filled' : 'empty'}
        onClick={(e) => {
          e.stopPropagation()
          props.onClick(column)
        }}
        placeholder={column.name.toString()}
        value={value}
        type="text"
        onChange={(e) => props.onChange(column.key, [e.target.value])}
      />
      {!!value && <i onClick={() => props.onChange(column.key, undefined)} className="icon-clear" />}
    </div>
  ) : null
}
